/* eslint-disable no-unused-expressions */
/* eslint-disable mdx/no-unused-expressions */
import { MDXProvider } from '@mdx-js/react'
import {
  Col,
  Container,
  Row,
  Tooltip,
  Button,
  Icon,
  Tabs as ArchTabs,
  Accordion,
  AccordionRow,
  Table as PayPalTable,
  Toast,
  Badge,
  Banner,
  Alert,
  HeadingText,
} from '@paypalcorp/pp-react'

import { graphql, Link } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import moment from 'moment'
import React, { useEffect, useLayoutEffect, useState, useCallback } from 'react'
import {
  CodeBlock,
  CodeBlockWrapper,
  NewCodeBlockWrapper,
  RunInPostman,
  YouTubeColumnLayout,
  YoutubeVideo,
  Pills,
  UITabs,
  NewCodeBlock,
  MultipartyForm,
  IntegrationCards,
  CompGrid,
  ImageLayout,
  ExperimentHoc,
  OpenInGitHubCodeSpaces,
} from '../components/layout'
import BreadCrumbs from '../components/layout/BreadCrumbs'
import CountryDropdown from '../components/layout/CountryDropdown/countryDropdown'
import Table from '../components/icons/Table'
import Layout from './layout'
import DropdownUtil from '../utils/DropdownUtil'
import { Tab, Tabs } from '../utils/Tabs'
import { NewCodeTab, NewCodeTabs } from '../utils/NewCodeTabs'
import ContentAccordion from '../utils/ContentAccordion'
import { ContentTabs, ContentTab } from '../utils/ContentTabs'
import { TableSearch } from '../utils/TableSearch'
import MarkdownLink from '../utils/Links'
import ImageLink from '../utils/Images'
import MailTo from '../components/MailTo'
import { PPCPBanner } from '../components/PPCPBanner'
// eslint-disable-next-line import/no-unresolved
import CurrencyTable from '../utils/CurrencyTable'
// eslint-disable-next-line import/no-unresolved
import PaymentTypesTable from '../utils/PaymentTypesTable'
// eslint-disable-next-line import/no-unresolved
import CountryTable from '../utils/CountryTable'
import CountryEligibility from '../utils/CountryEligibility'
// eslint-disable-next-line import/no-unresolved
import FundingTable from '../utils/FundingTable'
import { default as Lightbox } from 'react-image-lightbox'
import { DocumentIcon } from '../components/layout/Icons/DocumentIcon'
import { DocumentCheckIcon } from '../components/layout/Icons/DocumentCheckIcon'
import { CommunityIcon } from '../components/layout/Icons/CommunityIcon'
import { PlayButton } from '../components/layout/Icons/PlayButton'
import { FaqIcon } from '../components/layout/Icons/FaqIcon'
import { CodeIcon } from '../components/layout/Icons/CodeIcon'
import { OrdersIcon } from '../components/layout/Icons/OrdersIcon'
import { ArrowIcon } from '../components/layout/Icons/ArrowIcon'
import { CheckoutIcon } from '../components/layout/Icons/CheckoutIcon'
import { CheckIcon } from '../components/layout/Icons/CheckIcon'
import { SDKIcon } from '../components/layout/Icons/SDKIcon'
import { APMIcon } from '../components/layout/Icons/APMIcon'
import { PayLaterIcon } from '../components/layout/Icons/PayLaterIcon'
import { SecurityIcon } from '../components/layout/Icons/SecurityIcon'
import { VenmoIcon } from '../components/layout/Icons/VenmoIcon'
import { SandboxIcon } from '../components/layout/Icons/SandboxIcon'
import { PartnerIcon } from '../components/layout/Icons/PartnerIcon'
import { BellIcon } from '../components/layout/Icons/BellIcon'
import ImageContainer from '../components/ImageContainer'
import { SectionInView } from '../components/SectionInView'
import { AlertMessage } from '../components/AlertMessage'
import MultipartyBanner from '../components/layout/Home/Sections/MultipartyBanner'
import DropdownNav from '../utils/DropdownNav'
import CurrencyCardBrandTable from '../utils/CurrencyCardBrandTable'
// eslint-disable-next-line
import TestCardTable from '../utils/TestCardTable'
// eslint-disable-next-line
import RejectionTriggersTable from '../utils/RejectionTriggersTable'

import 'react-image-lightbox/style.css'
/*
  Base Template for each markdown pages.
*/
import '../css/ppvx.css'
import '../css/fonts-and-normalize.css'
import '../css/docs.css'
import './index.css'

import CheckoutGraphic from '../components/icons/CheckoutGraphic'
import { useApplicationContext } from '../provider'
import { Spacer } from '../components/layout/Spacer'
import { PaymentsDropdown } from '../components/layout/PaymentsDropdown'
import CreditCardGenerator from '../components/layout/CreditCardGenerator'
import NavigationTabs from '../components/layout/NavigationTabs'
import { SectionInViewContextProvider } from '../context/SectionInViewContext'
import NotificationBanner from '../components/layout/Home/Sections/NotificationBanner'
import DiscoveryCard from '../components/layout/DiscoveryCard/DiscoveryCard'
import ErrorCodesDropDown from '../utils/ErrorCodesDropDown'
import ThreeDSTestScenarios from '../utils/ThreeDSTestScenarios'
import SearchableTable from '../utils/SearchableTable'
import { TabsContainer, TabPanel } from '../components/TabsContainer'
import { KnowBeforeYouCodeWrapper } from '../components/KnowBeforeYouCode/KnowBeforeYouCodeWrapper'
import { KnowBeforeYouCodeCard } from '../components/KnowBeforeYouCode/KnowBeforeYouCodeCard'

const displayCountryDropdown = '/pay-later/'

const vaultDropdownRoutes = [
  '/beta/vault/during-purchase/js-sdk/',
  '/beta/vault/during-purchase/orders-api/',
  '/beta/vault/purchase-later/',
  '/docs/checkout/save-payment-methods/during-purchase/js-sdk/',
  '/docs/multiparty/checkout/save-payment-methods/during-purchase/js-sdk/',
  '/docs/checkout/save-payment-methods/during-purchase/orders-api/',
  '/docs/multiparty/checkout/save-payment-methods/during-purchase/orders-api/',
  '/docs/checkout/save-payment-methods/purchase-later/js-sdk/',
  '/docs/checkout/save-payment-methods/purchase-later/payment-tokens-api/',
  '/docs/multiparty/checkout/save-payment-methods/purchase-later/payment-tokens-api/',
  '/docs/multiparty/checkout/save-payment-methods/purchase-later/js-sdk/',
]
const displayPaymentsDropdown = new RegExp(vaultDropdownRoutes.join('|'), 'gi')

const components = {
  CodeBlock,
  OrdersIcon,
  VenmoIcon,
  SecurityIcon,
  SandboxIcon,
  PartnerIcon,
  APMIcon,
  PayLaterIcon,
  ArrowIcon,
  CheckoutIcon,
  SDKIcon,
  CommunityIcon,
  CurrencyTable,
  PlayButton,
  FaqIcon,
  CodeIcon,
  ArchTabs,
  FundingTable,
  PaymentTypesTable,
  Link,
  Tab,
  Tabs,
  ContentTab,
  CountryTable,
  CountryEligibility,
  ContentTabs,
  NewCodeTab,
  NewCodeTabs,
  CodeBlockWrapper,
  TableSearch,
  Col,
  ExperimentHoc,
  NewCodeBlock,
  NewCodeBlockWrapper,
  Banner,
  BellIcon,
  Lightbox,
  Row,
  Container,
  DropdownNav,
  Table,
  CheckoutGraphic,
  Tooltip,
  img: (props) => <ImageLink {...props} />,
  a: (props) => <MarkdownLink {...props} />,
  Spacer,
  RunInPostman,
  YouTubeColumnLayout,
  YoutubeVideo,
  Button,
  Icon,
  Pills,
  ContentAccordion,
  Accordion,
  AccordionRow,
  Toast,
  CreditCardGenerator,
  NavigationTabs,
  DocumentIcon,
  DocumentCheckIcon,
  Badge,
  SectionInView,
  ImageContainer,
  UITabs,
  PayPalTable,
  CheckIcon,
  MultipartyForm,
  IntegrationCards,
  CompGrid,
  ImageLayout,
  DropdownUtil,
  Alert,
  AlertMessage,
  CurrencyCardBrandTable,
  DiscoveryCard,
  HeadingText,
  MailTo,
  PPCPBanner,
  TestCardTable,
  RejectionTriggersTable,
  ErrorCodesDropDown,
  ThreeDSTestScenarios,
  SearchableTable,
  OpenInGitHubCodeSpaces,
  MultipartyBanner,
  TabsContainer,
  TabPanel,
  KnowBeforeYouCodeWrapper,
  KnowBeforeYouCodeCard,
}

const addAnchorsToTable = (tableRow) => {
  const list = Array.from(document.getElementsByTagName(tableRow))
  list.forEach((tr) => {
    let _anchorLink = tr.textContent.toLowerCase().trim().replace(/\s+/g, '-')
    tr.id = _anchorLink

    if (tr.textContent && tr.id) {
      if (
        tr.firstElementChild &&
        tr.firstElementChild.nodeName.toLowerCase() === `td`
      ) {
        let trChild = tr.firstElementChild
        if (trChild.childNodes.length) {
          tr.classList += `dx-anchor`

          let anchorLink = document.createElement(`a`)
          anchorLink.href = `#${_anchorLink}`
          anchorLink.setAttribute(`aria-hidden`, `true`)
          anchorLink.setAttribute(`pa-marked`, `1`)

          trChild.insertBefore(anchorLink, trChild.childNodes[0])
        }
      }
    }
  })
}

const emptyHeaders = (tableItem) => {
  let hideCount = 0
  let childCount = 0
  let tableHead = tableItem.firstElementChild

  if (tableHead && tableHead.nodeName.toLowerCase() === 'thead') {
    let tableRow = tableHead.firstElementChild
    if (tableRow && tableRow.nodeName.toLowerCase() === 'tr') {
      let thItem = tableRow.firstElementChild
      while (thItem && thItem.nodeName.toLowerCase() === 'th') {
        childCount++
        if (!thItem.textContent || thItem.textContent.trim() === '') {
          hideCount++
        }
        thItem = thItem.nextElementSibling
      }
    }
  } else if (tableHead && tableHead.nodeName.toLowerCase() === 'tbody') {
    let tableRow = tableHead.firstElementChild
    if (tableRow && tableRow.nodeName.toLowerCase() === 'tr') {
      let thItem = tableRow.firstElementChild
      while (thItem && thItem.nodeName.toLowerCase() === 'th') {
        childCount++
        if (!thItem.textContent || thItem.textContent.trim() === '') {
          hideCount++
        }
        thItem = thItem.nextElementSibling
      }
    }
  } else if (tableHead && tableHead.nodeName.toLowerCase() === 'colgroup') {
    let tableActualHead = tableHead.nextElementSibling
    if (tableActualHead && tableActualHead.nodeName.toLowerCase() === 'thead') {
      let tableRow = tableActualHead.firstElementChild
      if (tableRow && tableRow.nodeName.toLowerCase() === 'tr') {
        let thItem = tableRow.firstElementChild
        while (thItem && thItem.nodeName.toLowerCase() === 'th') {
          childCount++
          if (!thItem.textContent || thItem.textContent.trim() === '') {
            hideCount++
          }
          thItem = thItem.nextElementSibling
        }
      }
    }
  } else {
    return true
  }

  if (hideCount === childCount && hideCount > 0) {
    return true
  }

  return false
}

const addTableClasses = () => {
  const list = Array.from(document.getElementsByTagName('table'))

  list.forEach((tableItem) => {
    tableItem.classList.add('ppvx_table')
    tableItem.classList.add('ppvx_table-responsive-sm')
  })
}

const removeTableHeadingIfEmpty = () => {
  const list = Array.from(document.getElementsByTagName('table'))

  list.forEach((tableItem) => {
    if (emptyHeaders(tableItem)) {
      tableItem.classList.add('dx-table-lite')
    }
  })
}

const containsNumbers = (str) => {
  return /[0-9]/.test(str)
}

const newArchetypePages = [
  '/docs/checkout/advanced/sdk/v1/',
  '/api/rest/',
  '/docs/checkout/',
  '/beta/advanced-mobile/integrate-ios/',
  '/docs/multiparty/',
  '/docs/checkout/apm/apple-pay/',
  '/docs/checkout/apm/google-pay/',
  '/sdk/js/configuration/',
  '/docs/multiparty/get-started/',
  '/docs/multiparty/accept-payments/',
  '/docs/checkout/advanced/customize/card-fields/v1/style/',
  '/docs/checkout/advanced/customize/update-order-details/',
  '/docs/checkout/advanced/customize/handle-errors/',
  '/docs/checkout/advanced/customize/3d-secure/',
  '/docs/multiparty/seller-onboarding/',
  '/docs/community/paypalchampions/',
  '/docs/checkout/advanced/customize/sca-payment-indicators/',
  '/docs/checkout/advanced/card-decline-errors/',
  '/docs/checkout/advanced/customize/3d-secure/sdk/',
  '/docs/checkout/advanced/customize/card-fields/v1/events/',
  '/docs/checkout/advanced/customize/fraud-protection/',
  '/docs/checkout/advanced/customize/3d-secure/api/',
  '/docs/checkout/advanced/customize/3d-secure/response-parameters/',
  '/docs/checkout/advanced/customize/3d-secure/test/',
  '/docs/checkout/advanced/customize/reference-transactions/',
  '/docs/multiparty/seller-onboarding/after-payment/',
  '/docs/multiparty/seller-onboarding/build-onboarding/',
  '/tools/sandbox/card-testing/',
  '/docs/multiparty/seller-onboarding/before-payment/',
  '/docs/multiparty/checkout/advanced/integrate/',
  '/docs/multiparty/checkout/standard/integrate/',
  '/docs/multiparty/integration-checklist/',
  '/docs/multiparty/troubleshoot/',
  '/docs/multiparty/create-account/',
  '/docs/multiparty/seller-onboarding/after-payment',
  '/docs/checkout/standard/integrate/',
]

const ignoreHeadingList = [
  '3D Secure: Orders API',
  '3D Secure response parameters',
  'Integrate 3D Secure using JavaScript SDK',
  '3D Secure test scenarios',
  '3D Secure authentication',
]

export default function Home(props) {
  const { setRightNav, user } = useApplicationContext()
  const [rightNavs, setRightNavs] = useState([])
  const userLoggedIn = user && user.loggedIn
  const [isBannerHidden, setIsBannerHidden] = useState(false)
  const isNewArchetype = newArchetypePages.includes(props.location.pathname)

  const addAnchors = (heading, rightNavHrefs = []) => {
    let newHeading
    const list = Array.from(document.getElementsByTagName(heading))
    list.forEach((h) => {
      let anchorLink = h.textContent.toLowerCase().trim().replace(/\s+/g, '-')
      let newAnchor = 'link-'
      newAnchor += anchorLink.replace(/[^A-Za-z]+/g, '')

      h.id = anchorLink
      if (h.textContent) {
        if (
          containsNumbers(h.textContent) &&
          !ignoreHeadingList.includes(h.textContent) &&
          // !h.textContent.startsWith('3D') &&
          h.textContent.indexOf('Step') < 0
        ) {
          if (isNewArchetype) {
            let firstHalf = h.textContent
              .substring(0, h.textContent.indexOf(' '))
              .slice(0, -1)
            let secondHalf = h.textContent.substring(h.textContent.indexOf(' '))

            newHeading = !isNaN(firstHalf)
              ? `<span class="${
                  heading === 'h3' ? 'archSubHeading' : 'archHeading'
                }">${firstHalf}</span><span>${secondHalf}</span>`
              : h.textContent
          } else {
            newHeading = h.textContent
          }
        } else {
          newHeading = ''
        }
        h.classList += ' dx-anchor'
        h.classList += isNewArchetype ? ' newArchetype' : ''
        h.innerHTML = `<span class="headingAnchorLinks" id="${newAnchor}"></span><a class="dx-anchor__icon" href="#${newAnchor}" aria-hidden="true" pa-marked="1" tabIndex="-1"></a> ${
          newHeading ? newHeading : h.textContent
        }`
        heading === 'h2' &&
          rightNavHrefs.push({ content: h.textContent, id: newAnchor, a: 'a' })
      }
      document.getElementById(h.id).addEventListener('click', function () {
        const rightNavs = document.querySelectorAll('.rightNav-anchor')
        Array.from(rightNavs).forEach((rightNav) => {
          const href = rightNav.getAttribute('href').substring(1)
          if (href === newAnchor && !rightNav.classList.contains(href)) {
            setRightNav(href)
          }
        })
      })
    })
    return rightNavHrefs
  }
  const removeClassOrNodeFromDom = useCallback(
    () =>
      window.document
        .querySelector('.sidebar-title')
        ?.classList.remove('.dx-anchor'),
    [],
  )

  useEffect(() => {
    removeClassOrNodeFromDom()
    return () => {}
  }, [removeClassOrNodeFromDom])

  useEffect(() => {
    const sidebarTitle = window.document
      .querySelector('.sidebar-title a')
      ?.remove()

    return sidebarTitle
  }, [])

  // picking all the h2 tags and adding an anchor to it.
  useLayoutEffect(() => {
    const anchorHeadings = ['h1', 'h2', 'h3', 'h4', 'h5']
    anchorHeadings.forEach((heading) => {
      const rightNavHrefs = addAnchors(heading)
      // eslint-disable-next-line mdx/no-unused-expressions
      rightNavHrefs.length && setRightNavs(rightNavHrefs)
    })

    const tableItems = ['tr']
    tableItems.forEach((tableRow) => {
      addAnchorsToTable(tableRow)
    })

    removeTableHeadingIfEmpty()
    addTableClasses()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const {
    mdx: { frontmatter, body },
  } = props.data
  const filePath = props.data.mdx.fileAbsolutePath

  const isPayLater =
    filePath && filePath.includes(displayCountryDropdown) ? true : false
  const isPayWith =
    filePath && displayPaymentsDropdown.test(filePath) ? true : false
  /**
   **NOTE: Don't remove this, it is just a tweak
   **to make the PaymentsDropdown work
   **/
  displayPaymentsDropdown.test(filePath)

  let countrySelector = isPayLater ? <CountryDropdown /> : null
  let paymentSelector = isPayWith ? <PaymentsDropdown /> : null
  let subtitle = null
  if (
    frontmatter &&
    frontmatter.subtitle &&
    frontmatter.subtitle.trim() !== ``
  ) {
    subtitle = (
      <p className="dx-content-subtitle">
        {frontmatter && frontmatter.subtitle}
      </p>
    )
  }

  useEffect(() => {
    // Fire impression event to amplitude
    // camelCase is not allowed in FPTI Tags so using snake_case
    if (frontmatter.amplitude) {
      const [product, event_name, event_prop, event_value] =
        frontmatter.amplitude.split(',')
      const data = {
        product,
        event_name,
      }
      if (event_prop && event_value) {
        data.event_props = event_prop
        data[event_prop] = event_value
      }
      // eslint-disable-next-line mdx/no-unused-expressions
      // eslint-disable-next-line no-unused-expressions
      window?.PAYPAL?.analytics?.instance?.recordImpression({
        data,
      })
      if (window.fpti) {
        //clear the fpti data added above
        window.fpti.product = null
        window.fpti.event_name = null
        window.fpti.event_props = null
        window.fpti[event_prop] = null
      }
    }
  }, [frontmatter])

  const multiparty = props.location.pathname === '/docs/multiparty/'

  useEffect(() => {
    let hasHiddenBanner
    if (typeof window !== 'undefined') {
      hasHiddenBanner = localStorage.getItem('DocsBannerHidden')
      setIsBannerHidden(hasHiddenBanner === 'true')
    }
  }, [])

  // Handle click event
  const handleDismiss = () => {
    typeof window !== `undefined` &&
      localStorage.setItem('DocsBannerHidden', true)
    setIsBannerHidden(true)
  }

  const isPaypalChampion = props.location.pathname.includes(
    '/docs/community/paypalchampions/',
  )

  const marginStyle = () => {
    if (isPaypalChampion) {
      return '20px'
    } else if (isNewArchetype) {
      return '120px'
    }
  }

  return (
    <Layout
      rightNav={rightNavs}
      leftNavBar={true}
      layout="dx-docs"
      activeNavLocal
      location={props.location}
      title={frontmatter.title}
      description={frontmatter.description}
      ogImage={frontmatter.ogImage}
      keywords={frontmatter.keywords}
      contentType={frontmatter.contentType}
      productStatus={frontmatter.productStatus}
      apiVersion={frontmatter.apiVersion}
      sdkVersion={frontmatter.sdkVersion}
      sIntegration={frontmatter.sIntegration}
      aIntegration={frontmatter.aIntegration}
      amplitude={frontmatter.amplitude}
      fileAbsolutePath={filePath}
      hideRightNav={isNewArchetype}
    >
      <div id="hashLinkContainer" />
      <main
        className={
          isNewArchetype
            ? 'content dx-content noRightNav-main'
            : 'content dx-content'
        }
        id={userLoggedIn ? 'Authed' : 'Unauthed'}
      >
        <div
          className={isNewArchetype ? 'archetypeHeader' : ''}
          style={isNewArchetype ? { marginTop: '120px' } : {}}
        >
          {!isBannerHidden && (
            <NotificationBanner handleDismiss={handleDismiss} />
          )}
          <BreadCrumbs {...props} />
          <h1 className="dx-content-title ">
            {frontmatter && frontmatter.title}
          </h1>
          {subtitle}
          <p className="dx-status-wrapper">
            {frontmatter && frontmatter.contentType && !isNewArchetype && (
              <span className="dx-content-type">{frontmatter.contentType}</span>
            )}
            {frontmatter && frontmatter.contentType && isNewArchetype && (
              <Badge type="feature">{frontmatter.contentType}</Badge>
            )}
            {frontmatter && frontmatter.productStatus && !isNewArchetype && (
              <span className="dx-product-status">
                {frontmatter.productStatus}
              </span>
            )}
            {frontmatter && frontmatter.productStatus && isNewArchetype && (
              <Badge type="feature">{frontmatter.productStatus}</Badge>
            )}
            {frontmatter && frontmatter.sIntegration && (
              <span className="dx-sIntegration">
                {frontmatter.sIntegration}
              </span>
            )}
            {frontmatter && frontmatter.aIntegration && (
              <span className="dx-aIntegration">
                {frontmatter.aIntegration}
              </span>
            )}
            {frontmatter && frontmatter.date && (
              <span className="dx-product-lastUpdated">
                Last updated:{' '}
                {moment(frontmatter.date).format('MMMM Do YYYY, @ h:mm:ss a')}
              </span>
            )}
          </p>
          {countrySelector}
          {paymentSelector}
        </div>
        <br />
        <SectionInViewContextProvider>
          <MDXProvider components={components}>
            <MDXRenderer>{body}</MDXRenderer>
          </MDXProvider>
        </SectionInViewContextProvider>
        <div id="docsFeedback_bottomOfSection" />
      </main>
    </Layout>
  )
}

// query to get html and frontmatter
export const pageQuery = graphql`
  query ($fileAbsolutePath: String) {
    mdx(fileAbsolutePath: { eq: $fileAbsolutePath }) {
      body
      fileAbsolutePath
      frontmatter {
        title
        description
        subtitle
        keywords
        contentType
        productStatus
        ogImage
        apiVersion
        sdkVersion
        date
        sIntegration
        aIntegration
        amplitude
      }
    }
  }
`
